import { useState } from 'react'
import { Dialog, Typography, IconButton, Button } from '@mui/material'
import { Close } from '@mui/icons-material'
import { ActionText } from 'components/atoms/Text'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import RowStack from 'components/atoms/container/RowStack'
import InCardStack from 'components/atoms/container/InCardStack'
import colors from 'styles/colors'
import { getPopupConfig, setPopupConfig } from 'utils/localStorage'
import { useTranslation } from 'react-i18next'

const MEETING_STORAGE_KEY = 'hideRecurringMeeting'

const UpcomingMeetingNote = () => {
  const { t } = useTranslation()
  const messageHidden = getPopupConfig(MEETING_STORAGE_KEY)
  const [showMessage, setShowMessage] = useState(!messageHidden)
  const [openDialog, setOpenDialog] = useState(false)

  const toggleDialog = () => {
    setOpenDialog(!openDialog)
  }

  const hideMeetingMessage = () => {
    setShowMessage(false)
    setPopupConfig(MEETING_STORAGE_KEY, true)
  }

  return (
    <>
      {showMessage && (
        <RowStack
          spacing={6}
          sx={{
            borderWidth: 1,
            borderColor: colors.MutedTeal300,
            borderStyle: 'solid',
            borderRadius: 3,
            paddingX: 5,
            paddingY: 3,
            width: 'auto'
          }}>
          <RowStack spacing={4} width={'auto'}>
            <InfoOutlinedIcon sx={{ fontSize: 24 }} />
            <Typography variant='body1Small' color={colors.Grey400}>
              {t('myTeam.nextRecurringMeeting')}{' '}
              <ActionText
                sx={{
                  fontSize: 14,
                  textDecoration: 'underline',
                  textUnderlinePosition: 'from-font',
                  color: colors.Teal400
                }}
                onClick={toggleDialog}>
                {t('myTeam.more')}
              </ActionText>
            </Typography>
          </RowStack>

          <IconButton
            size='small'
            sx={{ padding: 0 }}
            onClick={hideMeetingMessage}>
            <Close sx={{ fontSize: 20, color: colors.Grey350 }} />
          </IconButton>
        </RowStack>
      )}

      <Dialog
        open={openDialog}
        onClose={toggleDialog}
        sx={{
          '& .MuiDialog-paper': {
            width: 420
          }
        }}>
        <InCardStack
          spacing={12}
          paddingX={12}
          paddingY={16}
          alignItems={'flex-end'}>
          <InCardStack spacing={4} alignItems={'flex-start'}>
            <Typography variant='h3' width={354}>
              {t('myTeam.onlySeeingSingleInstance')}
            </Typography>
            <Typography variant='body1'>
              {t('myTeam.helpYouStayFocused')}
            </Typography>
          </InCardStack>

          <Button onClick={toggleDialog}>{t('confidentiality.gotIt')}</Button>
        </InCardStack>
      </Dialog>
    </>
  )
}

export default UpcomingMeetingNote
